import { Tool } from '../../types';

export const schedulingTools: Tool[] = [
  {
    id: 'calendly',
    name: 'Calendly',
    category: 'Scheduling',
    description: 'The leading automated scheduling platform that eliminates back-and-forth emails for booking meetings. Set your availability, share your link, and let invitees pick a time. Integrates with calendars, video conferencing, and 700+ business apps.',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'integrations', 'mobile'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['consulting-firm', 'service-business'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['consulting', 'technology', 'marketing'],
    website: 'https://calendly.com',
    imageUrl: 'https://logo.clearbit.com/calendly.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  },
  {
    id: 'acuity',
    name: 'Acuity Scheduling',
    category: 'Scheduling',
    description: 'Powerful appointment scheduling software now part of Squarespace. Customizable booking pages, automated reminders, payment collection, and intake forms. Perfect for service businesses that need to manage client appointments efficiently.',
    pricing: ['low', 'medium'],
    features: ['automation', 'integrations', 'mobile'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['healthcare', 'consulting', 'creative'],
    website: 'https://acuityscheduling.com',
    imageUrl: 'https://logo.clearbit.com/acuityscheduling.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'youcanbook-me',
    name: 'YouCanBook.me',
    category: 'Scheduling',
    description: 'Straightforward booking solution that connects directly to your Google or Microsoft calendar. Clients self-schedule meetings, receive automatic confirmations, and get reminders. Budget-friendly alternative for teams needing simple scheduling.',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'integrations'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['streamline-operations'],
    industries: ['consulting', 'education', 'technology'],
    website: 'https://youcanbook.me',
    imageUrl: 'https://logo.clearbit.com/youcanbook.me',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];